// Contribution from Mercatura DeFi Team to Menese Protocol
// (2-of-2 Threshold ECDSA — Tier 7 browser + custody).
// Mercatura Forum proprietary.
//
// Tier-7 §1.I — combined-ship version pin. Must match
// `crates/nim-2party-wasm/src/lib.rs::MENESE_COMBINED_VERSION` and
// `canister/menese-2of2-canister/src/lib.rs::MENESE_COMBINED_VERSION`.
// The combined deploy script (§3.L) refuses to ship if these
// constants disagree across the three locations.

export const MENESE_COMBINED_VERSION = 1;
